module.exports = __webpack_public_path__ + "static/media/img12.619cf33b.jpg";